
    export default 
    {
    "publicDocument": {
        "warn": "Il nostro sistema ha rilevato che la password è troppo semplice da decifrare. Vai su Impostazioni-Account per reimpostare la password dopo l'accesso.",
        "newPass": "Inserisci una nuova password.",
        "safety": "La password non è sicura.",
        "scope": ""
    }
}